module.exports = __webpack_public_path__ + "4f9b5c46473c98c33882336f043aabb0.MP3";